import { useState } from "react";
import { toast } from "sonner";
import { useApi, useResource } from "@/lib/api";
import { PageHeader, Panel, StatusPill, Loading, ErrorNote } from "@/components/kit";

export default function Agents() {
  const { data, error, loading } = useResource("/agents");
  const call = useApi();
  const [result, setResult] = useState({});
  const attempt = async (id) => {
    try { await call(`/agents/${id}/execute`, { method: "POST" }); }
    catch (e) { setResult((r) => ({ ...r, [id]: e.message })); toast.error(e.message); }
  };
  if (loading) return <Loading />;
  if (error) return <ErrorNote error={error} />;
  return (
    <div>
      <PageHeader eyebrow="Governance · Registry" title="Agent Registry" />
      <p className="mb-6 max-w-2xl text-sm text-[var(--cc-muted)]">Seven future agents are registered. None has autonomous execution permissions in Phase 1. "Probe execution" sends a real request to verify the server rejects it.</p>
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {data.map((a) => (
          <Panel key={a.agent_id} testId={`agent-card-${a.agent_id}`}>
            <div className="flex items-start justify-between gap-2">
              <div>
                <p className="font-mono text-xs text-[var(--cc-muted)]">{a.agent_id}</p>
                <h3 className="mt-1 text-xl font-extrabold text-[var(--cc-navy)]">{a.name}</h3>
              </div>
              <StatusPill status={a.status} />
            </div>
            <dl className="mt-5 grid grid-cols-2 gap-3 text-xs">
              <div><dt className="text-[var(--cc-muted)]">Current level</dt><dd className="mt-0.5 font-mono font-medium" data-testid={`agent-level-${a.agent_id}`}>{a.permission_level} · none</dd></div>
              <div><dt className="text-[var(--cc-muted)]">Future target</dt><dd className="mt-0.5 font-mono">{a.future_level}</dd></div>
              <div><dt className="text-[var(--cc-muted)]">Autonomous execution</dt><dd className="mt-0.5 font-mono text-[var(--cc-deny)]" data-testid={`agent-exec-${a.agent_id}`}>{String(a.autonomous_execution)}</dd></div>
              <div><dt className="text-[var(--cc-muted)]">Can approve</dt><dd className="mt-0.5 font-mono text-[var(--cc-deny)]">{String(a.can_approve)}</dd></div>
            </dl>
            <button data-testid={`agent-probe-${a.agent_id}`} onClick={() => attempt(a.agent_id)} className="mt-5 w-full rounded-sm border border-[var(--cc-navy)] py-2 text-xs font-medium text-[var(--cc-navy)] transition-colors hover:bg-[var(--cc-navy)] hover:text-white">Probe execution</button>
            {result[a.agent_id] && <p className="mt-2 text-[11px] text-[var(--cc-deny)]" data-testid={`agent-probe-result-${a.agent_id}`}>403 · {result[a.agent_id]}</p>}
          </Panel>
        ))}
      </div>
    </div>
  );
}
